import { ColorsConstants } from 'src/app/shared/common';
import { Component, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommentCardComponent } from '../comment-card/comment-card.component';
import { DashboardCardWithTitleComponent } from 'src/app/shared/component/dashboard-card-with-title/dashboard-card-with-title.component';
import { ClientsRatingComponent } from '../clients-rating/clients-rating.component';
import { LayoutLoadingComponent } from 'src/app/shared/component/layout-loading/layout-loading.component';
import { TranslateModule } from '@ngx-translate/core';
import { WhiteLabelUsersCommentsWithRate } from 'src/app/core/data/model';

@Component({
  selector: 'app-comments-list',
  standalone: true,
  imports: [
    CommonModule,
    CommentCardComponent,
    DashboardCardWithTitleComponent,
    ClientsRatingComponent,
    LayoutLoadingComponent,
    TranslateModule,
  ],
  templateUrl: './comments-list.component.html',
  styleUrls: ['./comments-list.component.scss'],
})
export class CommentsListComponent implements OnInit {
  // inputs
  @Input() comments: WhiteLabelUsersCommentsWithRate;

  // constants
  ColorsConstants = ColorsConstants;

  constructor() {}

  ngOnInit(): void {}
}
